import React, { useState } from "react";
import { Container, Row, Col, Form, Button, Alert } from "react-bootstrap";
import "../../styles/General.css";
import "../../styles/Article.css";
import { supabase } from "../../config/Supabase";
import { trackNewsletterSubscribe } from "../../utils/analytics";

const SubscriptionComponent = () => {
  const [email, setEmail] = useState("");
  const [isValid, setIsValid] = useState(true); // State to track if the input is valid
  const [feedbackMessage, setFeedbackMessage] = useState("");

  // Function to validate email
  const validateEmail = (email) => {
    // Simple regex for basic email validation
    return /\S+@\S+\.\S+/.test(email);
  };

  // Handle input change
  const handleInputChange = (e) => {
    setEmail(e.target.value);
    // Validate the input as the user types
    setIsValid(validateEmail(e.target.value));
  };

  // Handle input blur (when the input loses focus)
  const handleInputBlur = () => {
    // Check if the input is empty or not a valid email when input loses focus
    setIsValid(email === "" || validateEmail(email));
  };

  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent default form submission behavior

    // Check for email validity before proceeding
    if (!validateEmail(email)) {
      setIsValid(false);
      setFeedbackMessage("Please enter a valid email address.");
      return;
    }

    try {
      // Store the email in the dedicated Supabase table (public anon insert).
      const { error } = await supabase
        .from("newsletter_subscribers")
        .insert({
          email: email.trim().toLowerCase(),
          source: window.location.pathname,
        });

      // 23505 = unique-violation: this address already subscribed. Treat that as
      // success (don't leak that the address exists, and don't show an error).
      const alreadySubscribed = error && error.code === "23505";
      if (error && !alreadySubscribed) {
        throw error;
      }

      setEmail("");
      setIsValid(true);
      setFeedbackMessage(
        alreadySubscribed
          ? "You're already subscribed — thank you!"
          : "You have been successfully subscribed!"
      );
      trackNewsletterSubscribe(true);
    } catch (error) {
      console.error("Error subscribing: ", error);
      setIsValid(false);
      setFeedbackMessage("An error occurred. Please try again.");
      trackNewsletterSubscribe(false);
    }
  };

  return (
    <Container className="py-5 px-3 px-md-4">
      <Form onSubmit={handleSubmit}>
        <Row>
          {/* Left Column */}
          <Col md={6} className="mb-4 mb-md-0">
            <Row>
              <p className="email-subscription-title">
                Bring health to your inbox
              </p>
            </Row>
            <Row>
              <p className="main-article-content">
                We'll send you content you'll not only enjoy reading but also
                want to apply.
              </p>
            </Row>
            <Row className="pe-md-4">
              <p className="main-article-content">
                By submitting, I consent to Sârv, and its affiliates contacting
                me by email at the address provided about its products and
                services.
              </p>
            </Row>
          </Col>

          {/* Right Column */}
          <Col md={6}>
            <Row>
              <Form.Group controlId="formBasicEmail">
                <Form.Control
                  type="email"
                  placeholder="Enter your email address"
                  className={`custom-subscribe-input ${
                    !isValid && "input-invalid"
                  }`} // Apply 'input-invalid' class if not valid
                  value={email}
                  onChange={handleInputChange}
                  onBlur={handleInputBlur}
                />
                {!isValid && (
                  <Form.Text style={{ color: "red" }}>
                    Please enter a valid email address.
                  </Form.Text>
                )}
              </Form.Group>
            </Row>
            <Row>
              {feedbackMessage && (
                <Row style={{ marginTop: "10px" }}>
                  <Alert variant={isValid ? "success" : "danger"}>
                    {feedbackMessage}
                  </Alert>
                </Row>
              )}
              <Button
                variant="primary"
                type="submit"
                className="custom-subscribe-btn"
              >
                Subscribe
              </Button>
            </Row>
          </Col>
        </Row>
      </Form>
    </Container>
  );
};

export default SubscriptionComponent;
